import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Util } from '@libs/utilities/util';

import { NgAbstractInputComponent } from '../shared/inputs.abstract';
import { EnumNgRadioButtonGroupSize, INgRadioButton, INgRadioButtonOptions } from './radio-button-group.interface';


@Component({
    selector: 'ng-radio-button-group',
    templateUrl: './radio-button-group.component.html',
    styleUrls: ['./radio-button-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: NgRadioButtonGroupComponent,
            multi: true
        }
    ],
    standalone: false
})
export class NgRadioButtonGroupComponent extends NgAbstractInputComponent<string> implements OnInit, ControlValueAccessor {

	//** Input properties */
	@Input() size		: EnumNgRadioButtonGroupSize   = EnumNgRadioButtonGroupSize.Medium;
	@Input() options	: INgRadioButtonOptions | null = null;
	@Input() buttonGroup: Array<INgRadioButton[]>	   = [];
	@Input() variant	: 'default' | 'view-switcher'   = 'default';

	constructor(
		private cdr: ChangeDetectorRef
	) {
		super('button-radio');
	}

	ngOnInit(): void {
		if (Util.Object.isEmpty(this.buttonGroup)) throw new Error(`ButtonRadioComponent => ngOnInit => FATAL ERROR: 'buttonGroup' options not provided.`);
	}

	updateValue(value: string): void {
		this.value = value;
		this.onChange(value);
		this.cdr.detectChanges();
	}
}
